import React from 'react'
import assets from '../assets'
import './index.css'
import { motion } from 'framer-motion'

const Table2 = ({variants}) => {
  return (
    <div className='section table2 '>
        <img className='circlesTable' src={assets.light.table2} alt="Circles" />
        <div className="container-lg flex flexCol alignCenter relative">
            {assets.arrowDown}
            <motion.h2
            variants={variants}
            initial={'initial'}
            whileInView={'inView'}
            transition={{ duration: 0.7, delay: .3 }}
            viewport={{ once: true }}
            >Synthetic listing comparison</motion.h2>
            <div className="overflowTable">
                <motion.table
                variants={variants}
                initial={'initial'}
                whileInView={'inView'}
                transition={{ duration: 0.7, delay: .5 }}
                viewport={{ once: true }}
                >
                    <thead>
                    <tr>
                        <th>Exchange</th>
                        <th>Decentralized back-end</th>
                        <th>Liquidity for listing token</th>
                        <th>Order book needed</th>
                        <th>Arbitrage vulnerable</th>
                        <th>Leverage tokes</th>
                        <th>Buy/Sell orders lag</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className='econSynTable'>Synthetic Ex</td>
                        <td>Optional</td>
                        <td>No</td>
                        <td>No</td>
                        <td>No</td>
                        <td>Up to 5x</td>
                        <td>Immediate</td>
                    </tr>
                    <tr>
                        <td>Coinbase</td>
                        <td>Centralized</td>
                        <td>Needed</td>
                        <td>Yes</td>
                        <td>No</td>
                        <td>No</td>
                        <td>Irregular</td>
                    </tr>
                    <tr>
                        <td>KuCoin</td>
                        <td>Centralized</td>
                        <td>Needed</td>
                        <td>Yes</td>
                        <td>Yes</td>
                        <td>Yes</td>
                        <td>Irregular</td>
                    </tr>
                    <tr>
                        <td>Huobi</td>
                        <td>Centralized</td>
                        <td>Needed</td>
                        <td>Yes</td>
                        <td>Yes</td>
                        <td>No</td>
                        <td>Irregular</td>
                    </tr>
                    <tr>
                        <td>Bitso</td>
                        <td>Centralized</td>
                        <td>Needed</td>
                        <td>Yes</td>
                        <td>No</td>
                        <td>No</td>
                        <td>Irregular</td>
                    </tr>
                    <tr>
                        <td>Sushi Swap</td>
                        <td>Descentralized</td>
                        <td>Needed</td>
                        <td>Yes</td>
                        <td>Yes</td>
                        <td>No</td>
                        <td>6min to 3h</td>
                    </tr>
                    
                    </tbody>
                </motion.table>
            </div>
        </div>
    </div>
  )
}

export default Table2